import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import ContactButton from '../components/contact/ContactButton';

import BlockWrapper from '../components/blocks/BlockWrapper';
import IconBlock from '../components/blocks/IconBlock';
import GenericBlock from '../components/blocks/GenericBlock';
import Slider from '../components/Slider';
import QuoteBar from '../components/QuoteBar';

import './AboutUs.css';

import backgroundImage from '../resources/img/slider-bg-pic2.jpg';
import logo from '../resources/img/logo-troi.png'

class AboutUs extends Component {

    constructor(props) {
        super(props);

        this.pageTitle = 'About Us';

        this.textLeft = (
            <h2>
                People at TROI are hard to put in a box. <br />
                We are curious, diverse and love learning.
            </h2>
        );

        this.textRight = (
            <span>{this.pageTitle.toUpperCase()}</span>
        );

        this.aboutUsItems = [
            /* Simply commenting this out as I don't want to lose the structure,
             * but also don't want this stuff to get into a production build
            {
                name: 'Person 1',
                jobtitle: 'Editor',
                description: 'Interdum et malesuada fames ac ante ipsum primis in faucibus. Pellentesque eu tincidunt elit, ac pharetra eros. Aenean tincidunt molestie augue, nec vulputate ipsum vestibulum ac. Donec quis turpis purus. Ut odio lorem, molestie ut blandit vel, suscipit eget eros. Donec ex urna, interdum vel turpis nec, tempor tincidunt tellus. Mauris at enim pellentesque, porttitor ex vel, aliquam nunc. Nam non semper odio, eget feugiat risus.',
                image: 'https://images.duckduckgo.com/iu/?u=http%3A%2F%2F4.bp.blogspot.com%2F-hJ2r9MozNUM%2FTWRKU4dHpAI%2FAAAAAAAAAEc%2FIh-lH2AbcDc%2Fs1600%2Fangry-person-istock.jpg&f=1'
            }, {
                name: 'Person 2',
                jobtitle: 'Animator',
                description: 'Duis ut sapien maximus, pulvinar ex vitae, ultricies neque. Donec eget mattis eros. Etiam sed luctus purus, id ultricies tortor. In laoreet imperdiet justo, in dapibus magna viverra nec. In eu elit eu orci accumsan vehicula at sit amet ante. Integer placerat metus non odio ultrices, a mollis urna feugiat. Duis commodo tellus sed interdum euismod. Pellentesque euismod in sapien ac vulputate. Ut rutrum accumsan metus ut placerat. Donec arcu lorem, dictum id nunc vitae, dictum blandit arcu. Fusce venenatis sapien sit amet imperdiet convallis. Sed odio lorem, efficitur vel augue vel, venenatis ornare ex. Nullam ultricies dictum sapien quis vestibulum.',
                image: 'https://images.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.Mce5dcf72b65a54b839fe1b461eb1cf01o0%26pid%3D15.1&f=1'
            }, {
                name: 'Person 3',
                jobtitle: 'Producer',
                description: 'Morbi elementum urna mauris, nec semper turpis fermentum et. Maecenas rutrum volutpat gravida. Suspendisse maximus, metus quis vulputate tristique, quam erat placerat massa, ut aliquet justo felis imperdiet mi. Praesent at velit et justo rhoncus iaculis. Nulla dapibus pharetra tristique. Cras finibus vestibulum eros, id condimentum nunc dapibus ut. Quisque et scelerisque lacus. Fusce vel eleifend diam.',
                image: 'https://images.duckduckgo.com/iu/?u=http%3A%2F%2Fstatic3.businessinsider.com%2Fimage%2F56feb17752bcd01b008ba4e8-480%2Fdonald-trump.jpg&f=1'
            }
            */
        ];
    }

    renderAboutUsItem(item, index) {
        return (
            <Row key={index} className="aboutus-item-row">
                <Col md={7}>
                    <h4>{item.name}</h4>
                    <h6>{item.jobtitle}</h6>
                    {item.description}
                </Col>
                <Col md={5} className="text-center">
                    <div className="img-box"
                        style={{backgroundImage: 'url('+ item.image +')'}} />
                </Col>
            </Row>
        );
    }

    componentDidMount() {
        document.title = 'TROI Studio | '+ this.pageTitle;
    }

    render() {
        return (
            <div>
                <ContactButton />

                <Slider backgroundImage={backgroundImage}
                    textLeft={this.textLeft}
                    textRight={this.textRight} />
                <QuoteBar text="" />

                <BlockWrapper>
                    <IconBlock className="hidden-xs hidden-sm" icon="play">
                        <h3>{this.pageTitle}</h3>
                    </IconBlock>

                    <GenericBlock>
                        <Col md={12}>
                            <h3>{this.pageTitle}</h3>
                        </Col>

                        <Col md={8} sm={8} xs={12}>
                            <p>
                                TROI has an inclusive equal opportunity philosophy and brings together diverse teams.
                                We like to work with people of different backgrounds, ages, and gender,
                                with diverse work experience and educational qualifications to create a unique team within
                                which everyone brings something different to the table.
                                We stay up-to-date with new trends and transformations in the realm of media, technology, and education.
                                Creative input and out-of-the-box thinking are our strong points.
                                We work as a team and consult multiple team members in the decision-making process.
                                This goes hand in hand with a communication on equal terms between all.
                            </p>

                            <p>
                                We are a brand which orchestrates access to a vast network of independent professionals.
                                These professionals specialise in the fields of media production, script writing, and animation,
                                who typically already worked with TROI on various other projects.
                                This means that there is always a big network of specialists to fall back onto.
                            </p>

                            <p>
                                At TROI Studio, we move away from meetings and annual personal performance evaluations.
                                Instead, we engage in a continuous dialogue and give feedback-on-the-job.
                                Membership varies per project and leadership rotates.
                                This keeps the work flowing and balanced, and creates an agile culture capable of adapting to new contexts fast.
                            </p>
                        </Col>

                        <Col md={4} sm={4} xs={12} className="text-center">
                            <img src={logo} alt="TROI Studio Logo" />
                        </Col>
                    </GenericBlock>
                </BlockWrapper>
            </div>
       );
    }

}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/pages/AboutUs.js